import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, FormatService, HelperService, HTTPService, ValidationService } from 'app/services';
import { config } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { currency } from 'app/constants/currency.constants';

import { orderBy, sum } from 'lodash';
import { TireDotNumberDialogComponent } from '../tire-dot-number-dialog/tire-dot-number-dialog.component';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-invoice-adjustment',
  templateUrl: './invoice-adjustment-dialog.component.html',
  styleUrls: ['./invoice-adjustment-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class InvoiceAdjustmentDialogComponent implements OnInit {
  cashPaymentRefunds: any = {
    name: '',
    amount: '',
    refundAmount: '',
    isRefundAmountFocus: false,
  };
  creditMemoRefunds: any = {
    name: '',
    amount: '',
    refundAmount: '',
    isRefundAmountFocus: false,
  };
  usd = currency.USD;
  remainingBalance: any = 0;
  paymentHistory: any = [];
  unpaidInvoices: any = [];
  focus: any = {};
  error: any = {};
  maxDateRange: any = new Date();
  payment: any = {
    _id: '',
    title: '',
    code: '',
    collectedAmount: null,
    estimate: {
      estimateId: '',
      title: '',
      code: '',
      invCode: '',
      estimateBy: '',
      cash: 0,
      cheque: 0,
      card: 0,
      creditPayment: 0,
      thirdParty: 0,
      total: 0,
      isFinalized: false,
      finalizeType: '',
    },
    notes: '',
  };
  paymentTime: any = '';
  estimate: any = {};
  validate: any = {
    amount: 0,
    range: 0,
  };
  orderId: string = '';
  originalOrderId: string = '';
  refundRemaining: number = 0;
  refundApplied: number = 0;
  isProcessing: boolean = false;
  isLoading: boolean = true;
  isFinalized: boolean = false;
  isQboConnected: boolean = false;
  disableRefundAmount:boolean = false;
  disableCreditMemoRefunds:boolean = false
  customerId: string = '';
  creditAppliedAmount: any;
  checkTxt: string = '';
  loader = {
    isPaymentLoading: true,
    isUnpaidInvoiceLoading: true,
  };
  summary = {
    refundAmount: 0,
    creditAmount: 0,
  };
  title: string = '';
  changePaymentData = false;
  isPaymentDataPrivilgesEnabled: boolean = false;
  isDotNumberReqOnInv: boolean = false;
  isDotValid = undefined;
  validations: any = {};
  unassignedServices: any = {};
  dataSubscription: Subscription;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public validationService: ValidationService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    const data = this.dConfig.data;
    this.orderId = data.estimate?._id;
    this.customerId = data.estimate?._id;
    this.checkTxt = this.dataService.checkTxt;
    this.isDotNumberReqOnInv = this.dataService.isDotNumberReqOnInv;
    this.estimate = await this.httpService.getEstimateById(this.orderId);
    if (this.isDotNumberReqOnInv) {
      this.validateDot()
    } else {
      this.isDotValid = true;
    }
    this.getSettlements()

    if (this.orderId) {
      this.setEstimateDetails();
      this.title = [this.payment?.customer?.displayName, this.payment?.customer?.email].filter((str) => str).join(' - ');
    }
    this.changePaymentData = this.dataService.changePaymentData;
    this.isPaymentDataPrivilgesEnabled = this.dataService.isPaymentDataPrivilgesEnabled;
    this.dataSubscription = this.dataService.getData().subscribe((payload) => {
      if (payload.data && payload.data.key === 'authorization-dialog') {
        this.getSettlements();
        this.dataService.sendData(this.dataService.typePassData('partial-order-reload', {}));
        this.dataSubscription.unsubscribe();
      }
    });
  }

  async getSettlements() {
    const details: any = await this.httpService.getOrderSettlementDetails(this.orderId, { fetchPayMethods: true });
    if (details?.validations) {
      this.validations = details.validations;
      this.unassignedServices = this.helperService.getUnassignedSalesCodeServiceItems(this.orderId, this.estimate.services, 'pending');
    }
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  closePaymentModal(data: any, isTransactionDone: boolean = false) {
    this.ref.close(data);
  }

  handleChange(value: any, obj: any, field: string, type? :string) {
    obj[field] = value;
    this.calculateRemainingRefunds(value);

    this.isQboConnected = this.helperService.getCompany().qbo;
    if(this.isQboConnected) {
      this.validateCreditMemo(obj,type)
    }
  }

  validateCreditMemo (obj, type?) {
    if(type === 'creditMemoRefunds' && this.isQboConnected) {
      if(this.creditMemoRefunds?.isRefundAmountFocus && obj.refundAmount) {
        this.unpaidInvoices.forEach((data, index:number) => {
          this.unpaidInvoices[index].invoiceRefundAmount = true;
        });
        this.disableRefundAmount = true
      } else if(obj.refundAmount === '' || Number(obj.refundAmount) === 0) {
        this.disableRefundAmount = false;
        this.unpaidInvoices.forEach((data, index:number) => {
          this.unpaidInvoices[index].invoiceRefundAmount = false;
        });
      }
  } else if (type === 'cashPaymentRefunds' && this.isQboConnected) {
    if(this.cashPaymentRefunds?.isRefundAmountFocus && obj.refundAmount) {
      this.disableCreditMemoRefunds = true
      this.unpaidInvoices.forEach((data, index:number) => {
        this.unpaidInvoices[index].invoiceRefundAmount = true;
      });
    } else if(obj.refundAmount === '' || Number(obj.refundAmount) === 0) {
      this.disableCreditMemoRefunds = false;
      this.unpaidInvoices.forEach((data, index:number) => {
        this.unpaidInvoices[index].invoiceRefundAmount = false;
      });
    }
  }else if(type === 'invoiceRefundAmount' && this.isQboConnected){
    this.unpaidInvoices.forEach((data, index:number) => {
        if(data._id !== obj._id){;
          this.unpaidInvoices[index].invoiceRefundAmount = true;
          this.disableRefundAmount = true
          this.disableCreditMemoRefunds = true
        }
       if(obj.refundAmount === '' || Number(obj.refundAmount) === 0) {
          this.unpaidInvoices[index].invoiceRefundAmount = false;
          this.disableRefundAmount = false
          this.disableCreditMemoRefunds = false
      }
    });
  }
  }

  handleFocus(refundObj: any, type?: string) {
    refundObj.isRefundAmountFocus = true;
  }

  handleBlur(refundObj: any, type?: string) {
    refundObj.isRefundAmountFocus = false;
    this.calculateRemainingRefunds();
  }

  /** Populate Estimate Details */
  async setEstimateDetails() {
    try {
      const order = await this.httpService.getEstimateById(this.orderId);
      this.isFinalized = order.isFinalized;
      this.payment = {
        // ...this.payment,
        title: order.title,
        code: order.code,
        paymentType: {},
        collectedAmount: 0,
        isPaidFull: order.isPaidFull,
        workFlowPaid: order.workFlowStatus?.name,
        customer: {
          customerId: order.customer?.customerId,
          fullName: order.customer?.fullName,
          email: order.customer?.email,
          phone: order.customer?.phone,
          phone2: order.customer?.phone2,
          notes: order.customer?.notes,
          displayName: order.customer?.displayName,
          isFleetCustomer: order.customer?.isFleetCustomer,
        },
        estimate: {
          estimateId: order._id,
          title: order.title,
          code: order.code,
          invCode: order.invCode,
          orderStatus: order.orderStatus,
          estimateBy: '',
          workFlowStatus: order.workFlowStatus?.name || '',
          cash: this.calculationService.roundOff(order.cash),
          cheque: this.calculationService.roundOff(order.cheque),
          card: this.calculationService.roundOff(order.card),
          creditPayment: this.calculationService.roundOff(order.creditPayment),
          thirdParty: this.calculationService.roundOff(order.thirdParty),
          total: order.total.grand,
          totalDue: order.total.grand,
          unpaid: order.total.unpaid,
          createdAt: this.dateService.getCurrentDateTimeTz(new Date(order.backdatedCreationDate || order.createdAt).getTime()),
          isFinalized: order.isFinalized,
          finalizeType: order.finalizeType,
          paid: sum([
            this.calculationService.roundOff(order.card),
            this.calculationService.roundOff(order.cash),
            this.calculationService.roundOff(order.cheque),
            this.calculationService.roundOff(order.creditPayment),
            this.calculationService.roundOff(order.thirdParty),
          ]),
          adjustmentsForInvoice: order.adjustmentsForInvoice,
        },
        paymentDate: this.dateService.getCurrentDateTimeTz(order.currentTime),
      };
      this.paymentTime = this.dateService.getCurrentDateTimeTz(order.currentTime);
      this.originalOrderId = this.payment.estimate?.adjustmentsForInvoice?.orderId;
      this.getOriginalOrderPayment();
      this.getUnpaidInvoices(order.customer?.customerId._id);
      this.calculateRemainingRefunds();
      this.isLoading = false;
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  onChangenNote(event: any) {
    this.payment.customer.notes = event;
  }

  /**
   * Fetching payments made on the original order so we can adjust payments against it.
   * This function will fetch and format the payments
   *
   * @memberof InvoiceAdjustmentDialogComponent
   */
  async getOriginalOrderPayment() {
    try {
      this.loader.isPaymentLoading = true;
      const payments: any = await this.httpService.getPaymentHistoryByOrderId(this.originalOrderId);
      this.paymentHistory = [];
      this.setOriginalOrderPayments(payments);
      this.applyRefundsOnPayments();
      this.cdr.detectChanges();
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isPaymentLoading = false;
    }
  }

  /**
   * Format and set payments of original order
   *
   * @param {any[]} payments
   * @return {*}  {*}
   * @memberof InvoiceAdjustmentDialogComponent
   */
  setOriginalOrderPayments(payments: any[]): any {
    this.paymentHistory = [];
    if (!payments?.length) return;

    this.paymentHistory = payments.map((payment: any) => {
      if (!!payment.paymentDate) {
        payment.createdAt = new Date(payment.paymentDate);
      } else {
        payment.createdAt = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
      }
      // need this flag in tooltip
      payment.tooltip = this.helperService.createPaymentLogTooltip(payment);

      payment.refunds = payment.refunds.map((refund: any) => {
        refund.tooltip = this.helperService.createRefundTooltip(refund, payment);
        refund.refundDate = this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime());
        refund.isVoidPayment = refund.isVoid;

        return refund;
      });

      payment.refunds = orderBy(payment.refunds, ['refundDate'], 'desc');

      if (payment.isCreditPayment) {
        payment.paymentHistory.map((credit) => {
          payment.creditMethodType = credit.paymentMethod.replace('Memo', 'Memo Applied');
        });
      }

      return payment;
    });
  }

  /**
   * Auto apply refund amount against the payments if there's still any amount left then send it to cash refunds
   *
   * @return {*}
   * @memberof InvoiceAdjustmentDialogComponent
   */
  applyRefundsOnPayments(): any {
    if (!this.paymentHistory.length) return;

    let totalApplicableAmount = this.calculationService.roundOff(this.abs(this.payment?.estimate?.total));

    this.paymentHistory.forEach((payment: any) => {
      if (totalApplicableAmount >= payment.amount) {
        payment.refundAmount = payment.amount;
      } else {
        payment.refundAmount = totalApplicableAmount;
      }

      totalApplicableAmount = this.calculationService.roundOff(totalApplicableAmount - payment.refundAmount);
    });

    this.cashPaymentRefunds.refundAmount = totalApplicableAmount;
  }

  /**
   * Fetching all unpaid invoices of the current customers so use can apply the adjustment balance on old invocies.
   * This function will fetch and format the unpaid invoices
   *
   * @param {string} customerId
   * @memberof InvoiceAdjustmentDialogComponent
   */
  async getUnpaidInvoices(customerId: string) {
    try {
      this.loader.isUnpaidInvoiceLoading = true;
      const history: any = await this.httpService.getROBalanceHistoryByCustomerId(customerId);

      this.unpaidInvoices = this.setunpaidInvoices(history);
      this.calculateRemainingRefunds();
      this.cdr.detectChanges();
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isUnpaidInvoiceLoading = false;
    }
  }

  /**
   * Format the date and create the text for showing old invoices
   * This function convert and format the invoice time and create label
   *
   * @param {any[]} invoices
   * @return {*}  {any[]}
   * @memberof InvoiceAdjustmentDialogComponent
   */
  setunpaidInvoices(invoices: any[]): any[] {
    this.creditAppliedAmount = 0;
    if (!invoices?.length) return [];

    return invoices.map((invoice: any) => {
      invoice.balanceText = `RO# ${invoice.code}`;

      if (invoice.orderStatus === 'invoice') {
        const invoiceDateTz = this.dateService.getCurrentDateTimeTz(new Date(invoice.invoiceDate).getTime());
        const invoiceDate = this.dateService.formatDate(invoiceDateTz, datetimeFormat.mmmdyyyy);

        invoice.balanceText += ` Invoice# ${invoice.invCode} (${invoiceDate})`;
      }

      invoice.refundAmount = 0;

      return invoice;
    });
  }

  calculateRemainingRefunds(value?: any) {
    let totalRefund = 0;

    totalRefund += this.calculationService.roundOff(this.cashPaymentRefunds.refundAmount);
    totalRefund += this.calculationService.roundOff(this.creditMemoRefunds.refundAmount);
    this.paymentHistory.forEach(({ refundAmount }) => {
      if (refundAmount) {
        totalRefund += this.calculationService.roundOff(refundAmount);
      }
    });
    this.unpaidInvoices.forEach(({ refundAmount }) => {
      if (refundAmount) {
        totalRefund += this.calculationService.roundOff(refundAmount);
      }
    });

    this.refundApplied = this.calculationService.roundOff(totalRefund);
    this.refundRemaining = this.calculationService.roundOff(Math.abs(this.payment.estimate.total) - this.refundApplied);
  }

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.ref.close({ isSuccess, data });
  }

  /**
   * Validate the API payload if it's correct or is there any issue with the data
   *
   * @memberof InvoiceAdjustmentDialogComponent
   */
  isValid() {
    let isValid = true;
    /** Need to confirm if we need the validation for payment amounts */
    // this.paymentHistory?.forEach(({ _id, amount, refundAmount }, index: number) => {
    //   if (refundAmount > amount) {
    //     this.paymentHistory[index].error = `Refund cannot be greater than payment amount`;
    //     isValid = false;
    //   }
    // });
    this.unpaidInvoices?.forEach(({ _id, total, refundAmount }, index: number) => {
      if (refundAmount > total?.grand) {
        this.unpaidInvoices[index].error = `Refund cannot be greater than payment amount`;
        isValid = false;
      }
    });

    if (this.refundRemaining !== 0) {
      isValid = false;
    }

    this.cdr.detectChanges();
    return isValid;
  }

  /**
   * Make payload for sending the data to the backend for payment adjustments
   *
   * @return {*}
   * @memberof InvoiceAdjustmentDialogComponent
   */
  makePayload(): any {
    const paymentRefunds = [];
    const appliedCreditRefunds = [];

    this.paymentHistory?.forEach(({ _id, amount, refundAmount }, index: number) => {
      if (refundAmount) {
        paymentRefunds.push({
          paymentId: _id,
          orderId: this.originalOrderId,
          amount: refundAmount,
        });
      }
    });
    this.unpaidInvoices?.forEach((invoice: any, index: number) => {
      if (invoice.refundAmount) {
        appliedCreditRefunds.push({
          invoiceId: invoice._id,
          orderId: this.originalOrderId,
          amount: invoice.refundAmount,
          title: invoice.title,
          code: invoice.code,
          invCode: invoice.invCode,
        });
      }
    });

    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    const payload = {
      orderId: this.orderId,
      originalOrderId: this.originalOrderId,
      refundDate: `${date} ${time}`,
      paymentRefunds: paymentRefunds,
      appliedCreditRefunds: appliedCreditRefunds,
      cashRefund: this.cashPaymentRefunds.refundAmount,
      creditMemoRefund: this.creditMemoRefunds.refundAmount,
      notes: this.payment.notes,
    };

    return payload;
  }

  async onSubmit() {
    if (this.isProcessing || this.isFinalized) return;
    if (!this.isValid()) return;

    try {
      this.isProcessing = true;
      const payload = this.makePayload();
      console.log('payload ===>>>', payload);
      await this.httpService.createAdjustmentRefundAndFinalize(payload);
      this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
      this.handleClose(true);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }

  abs(amount: number) {
    return Math.abs(amount);
  }

  validateDot() {
    const estimate = this.estimate;
    this.isDotValid = true;
    estimate.services = estimate.services ? estimate.services : estimate.service;
    if (!estimate?.services) return;
  
    this.isDotValid = estimate.services.every(service => 
      service.items.every(item => {
        const itemsToCheck = item?.subItems?.length ? item.subItems : [item];
        
        return itemsToCheck.every(subItem => {
          if (subItem.type === 'tire') {
            const count = this.abs(subItem.count);
            
            if (subItem.dotNumbers?.length) {
              return subItem.dotNumbers.length === count && subItem.dotNumbers.every(dot => dot?.dotNumber !== '');
            } else if (((!subItem.dotNumbers?.length && count !== 0) || subItem.dotNumbers.some(dot => dot?.dotNumber === ''))) {            
              return false;
            }
          }
          return true;
        });
      })
    );
  }

  openTireDotNumberModal() {
    const estimate = this.estimate;
    const ref = this.dialogService.open(TireDotNumberDialogComponent, {
      width: '30%',
      styleClass: 'add-dialog tire-dot-number-dialog',
      showHeader: false,
      data: {
        dotNumberTitle: 'Missing Information',
        estimate,
        unassignedServices: this.unassignedServices
      },
    });

    const onClose = ref.onClose.subscribe(async ({ isSuccess, dotNumbers }) => {
      if (isSuccess) {
        const promises = [];
        const details: any = await this.httpService.getOrderSettlementDetails(this.orderId, { fetchPayMethods: true });
        if (details?.validations) {
          this.validations = details.validations;
          this.unassignedServices = this.helperService.getUnassignedSalesCodeServiceItems(this.orderId, this.estimate.services, 'pending');
        }
        estimate?.services?.forEach(service => {
          service?.items?.forEach(item => {
            if (item?.subItems?.length) {
              item?.subItems.forEach(subItem => {
                const existsAt = dotNumbers.findIndex(si => si.id === subItem._id)
                if (existsAt > -1) {
                  let dots = [] 
                  if (dotNumbers[existsAt]?.dotNumbers?.length) {
                    dots = dotNumbers[existsAt]?.dotNumbers?.map(dn => {
                      return {
                        ...dn,
                        tirePosition: dn.tirePosition.value
                      }
                    })
                  }
                  const data = {
                    orderId: estimate._id, 
                    serviceId: service._id,
                    parentItemId: item._id,
                    tireId: subItem?._id, 
                    dotNumbers: dots,
                  };
                  promises.push(this.httpService.updateTireDotNumber(data));
                }
              })
            } else {
              const existsAt = dotNumbers.findIndex(i => i.id === item._id)
              if (existsAt > -1) {
                let dots = [] 
                if (dotNumbers[existsAt]?.dotNumbers?.length) {
                  dots = dotNumbers[existsAt]?.dotNumbers?.map(dn => {
                    return {
                      ...dn,
                      tirePosition: dn.tirePosition.value
                    }
                  })
                }
                const data = {
                    orderId: estimate._id, 
                    serviceId: service._id,
                    tireId: item?._id,
                    dotNumbers: dots, 
                  };
                  promises.push(this.httpService.updateTireDotNumber(data));
              }
            }
          })
        })

        Promise.allSettled(promises).then(async results => {
          const allSuccess = results.every(result => result.status === 'fulfilled');
          if (!allSuccess) {
            results.forEach((result, index) => {
              if (result.status !== 'fulfilled') {
                console.log(`Promise ${index + 1} failed with reason:`, result.reason);
              }
            });
          } else {
            // this.estimate = await this.httpService.getOrderServices(this.orderId)
            // this.estimate.services = this.estimate.service
            // this.estimate._id = this.orderId;
            // this.validateDot()
            if(this.orderId) {
              try {
                const order = await this.httpService.getEstimateById(this.orderId);
                this.estimate = order;
                this.estimate._id = this.orderId;
                this.validateDot();
              } catch(err) {
                this.helperService.showToaster('error', err);
              }
              
            }
            
          }
          this.dataService.sendData(this.dataService.typePassData('partial-order-reload', {}));
          onClose.unsubscribe();
        });
      }
    });
  }

}

// setCreditRefund(value) {
//   this.creditAppliedAmount = 0;

//   if (Number(this.refundRemaining) < 0) {
//     this.error.creditAmount = 'Amount cannot exceed remainig refund amount';
//   } else {
//     this.error.creditAmount = '';
//   }

//   let totalCreditAmount = value;
//   if (this.unpaidInvoices && this.unpaidInvoices.length >= 0) {
//     this.unpaidInvoices.forEach((element) => {
//       element.creditRefundFocus = false;
//       element.creditFocus = false;

//       if (element.creditRefundValue === null || element.creditRefundValue === undefined) {
//         element.creditRefundValue = 0;
//       }

//       let unpaid = element.total.unpaid;
//       if (totalCreditAmount > unpaid) {
//         element.creditRefundValue = unpaid;
//         totalCreditAmount = (totalCreditAmount - element.creditRefundValue).toFixed(2);
//         unpaid = 0;
//       }

//       if (unpaid > 0) {
//         if (totalCreditAmount > unpaid) {
//           element.creditRefundValue = unpaid;
//         } else {
//           element.creditRefundValue = Number(totalCreditAmount).toFixed(2);
//         }
//         totalCreditAmount = Number(totalCreditAmount - element.creditRefundValue).toFixed(2);
//       }

//       this.creditAppliedAmount += Number(element.creditRefundValue);
//     });
//   }
// }

// handleCreditRefundChange(value: any, index: any) {
//   this.unpaidInvoices[index].creditRefundValue = value;
//   if (value > this.unpaidInvoices[index].total.unpaid) {
//     this.unpaidInvoices[index].creditRefundFocus = true;
//   } else {
//     this.unpaidInvoices[index].creditRefundFocus = false;
//   }
//   this.unpaidInvoices = this.setunpaidInvoices(this.unpaidInvoices);

//   if (Number(this.creditAppliedAmount) > Number(this.creditMemoRefunds.refundAmount)) {
//     this.unpaidInvoices[index].creditFocus = true;
//   } else {
//     this.unpaidInvoices[index].creditFocus = false;
//   }
// }
